import React from "react";
import { Link } from "react-router-dom";
import { Table, Icon } from "semantic-ui-react";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../../../commons/functions/generalFunctions";
const DescriptionTable = ({ item }) => {
  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign="center">Código</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Nombre</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            Texto Personalizado
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            Costo de Texto Personalizado
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Cantidad</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Precio Unidad</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Total</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Ver</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {item.orderHistory.map((product, key) => (
          <Table.Row key={key}>
            <Table.Cell textAlign="center">{product.code}</Table.Cell>
            <Table.Cell textAlign="center">{product.name}</Table.Cell>
            <Table.Cell textAlign="center">
              {product.customText ? product.customText : "No"}
            </Table.Cell>
            <Table.Cell textAlign="center">
              {item.currency === "USD"
                ? formatterUSD.format(parseFloat(product.customizationCost))
                : formatCurrency(parseFloat(product.customizationCost))}
            </Table.Cell>
            <Table.Cell textAlign="center">{product.quantity}</Table.Cell>
            <Table.Cell textAlign="center">
              {item.currency === "USD"
                ? formatterUSD.format(parseFloat(product.price))
                : formatCurrency(parseFloat(product.price))}
            </Table.Cell>
            <Table.Cell textAlign="center">
              {item.currency === "USD"
                ? formatterUSD.format(parseFloat(product.total))
                : formatCurrency(parseFloat(product.total))}
            </Table.Cell>
            <Table.Cell textAlign="center">
              <Link to={`/product/${product.id}`}>
                <Icon name="eye" />
              </Link>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default DescriptionTable;
